import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagAlcohol = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 21,
	viewBox: "0 0 21 21",
	width: 21,
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "m.431641.014648h20v20h-20z" })
	}), /* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "m19.6241 3.32281-2.5-2.500001c-.1172-.117276-.2763-.183161-.4422-.183161-.1658 0-.3249.065885-.4421.183161-.1173.117275-.1832.276331-.1832.442191 0 .16585.0659.32491.1832.44218l.1156.11485-4.3102 3.23281-2.98591.59766c-.12091.02422-.23202.08344-.31953.17031l-6.51094 6.50939c-.35161.3516-.54913.8285-.54913 1.3258 0 .4972.19752.9741.54913 1.3257l3.23437 3.2344c.35163.3516.82853.5492 1.32579.5492.49725 0 .97415-.1976 1.32578-.5492l6.50934-6.5086c.0871-.0873.1463-.1985.1703-.3195l.5977-2.98594 3.2328-4.31016.1149.11563c.058.05807.127.10413.2028.13556.0759.03142.1572.0476.2393.0476.0822 0 .1635-.01618.2394-.0476.0758-.03143.1448-.07749.2028-.13556.0581-.05807.1042-.12701.1356-.20288s.0476-.15719.0476-.23931-.0162-.16344-.0476-.23931-.0775-.14481-.1356-.20288zm-12.83512 14.19219c-.08201.0002-.16325-.0158-.23901-.0472-.07577-.0314-.14456-.0775-.2024-.1356l-3.23281-3.2328c-.11713-.1172-.18292-.2761-.18292-.4418s.06579-.3246.18292-.4418l.44218-.4422 4.11641 4.1164-.44453.4422c-.11674.1166-.27485.1823-.43984.1828zm7.51792-9.75c-.056.07456-.0945.16082-.1125.25234l-.5882 2.93986-.6743.6742-4.11636-4.1164.67422-.67422 2.93984-.58828c.0915-.018.1778-.05646.2523-.1125l4.5665-3.425.4835.48359z",
			fill: "current"
		})
	})]
});
export default SvgFlagAlcohol;
